import { render, staticRenderFns } from "./PostulantsList.vue?vue&type=template&id=a771ba90&scoped=true&"
import script from "./PostulantsList.vue?vue&type=script&lang=js&"
export * from "./PostulantsList.vue?vue&type=script&lang=js&"
import style0 from "./PostulantsList.vue?vue&type=style&index=0&id=a771ba90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a771ba90",
  null
  
)

export default component.exports